export const toPersianDigits = (str) => {
    if (!str && str !== 0) return "";
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    return str.toString().replace(/\d/g, (d) => persianDigits[d]);
};
